import { ExistingPaymentMethodForInvoice } from 'tools/constants/payPortal';

export type AllowedPaymentMethodKey =
  | 'creditcard'
  | 'ach'
  | 'googlepay'
  | 'applepay'
  | 'check'
  | 'cash'
  | 'other';

export const PAYMENT_METHOD_KEY = {
  ACH: 'ach',
  APPLE_PAY: 'applepay',
  CASH: 'cash',
  CHECK: 'check',
  CREDIT_CARD: 'creditcard',
  GOOGLE_PAY: 'googlepay',
  OTHER: 'other',
} as const;

export interface PaymentMethodOption {
  key: AllowedPaymentMethodKey;
  label: string;
}

export const ALLOWED_PAYMENT_METHOD_OPTIONS: PaymentMethodOption[] = [
  { key: PAYMENT_METHOD_KEY.CREDIT_CARD, label: 'Credit Card' },
  { key: PAYMENT_METHOD_KEY.ACH, label: 'Bank Account (ACH)' },
  { key: PAYMENT_METHOD_KEY.GOOGLE_PAY, label: 'Google Pay' },
  { key: PAYMENT_METHOD_KEY.APPLE_PAY, label: 'Apple Pay' },
  { key: PAYMENT_METHOD_KEY.CHECK, label: 'Check' },
  { key: PAYMENT_METHOD_KEY.CASH, label: 'Cash' },
  { key: PAYMENT_METHOD_KEY.OTHER, label: 'Other' },
];

export const ALL_PAYMENT_METHOD_KEYS: AllowedPaymentMethodKey[] =
  ALLOWED_PAYMENT_METHOD_OPTIONS.map((o) => o.key);

/**
 * Maps payment-method dropdown enum values (shared by
 * ExistingPaymentMethods & ExistingPaymentMethodForInvoice)
 * to their config key counterpart.
 */
export const PAYMENT_METHOD_CONFIG_KEY_MAP: Record<
  string,
  AllowedPaymentMethodKey
> = {
  [ExistingPaymentMethodForInvoice.PayWithCard]: PAYMENT_METHOD_KEY.CREDIT_CARD,
  [ExistingPaymentMethodForInvoice.PayWithBank]: PAYMENT_METHOD_KEY.ACH,
  [ExistingPaymentMethodForInvoice.PayWithGooglePay]:
    PAYMENT_METHOD_KEY.GOOGLE_PAY,
  [ExistingPaymentMethodForInvoice.PayWithApplePay]:
    PAYMENT_METHOD_KEY.APPLE_PAY,
  [ExistingPaymentMethodForInvoice.PayWithCash]: PAYMENT_METHOD_KEY.CASH,
  [ExistingPaymentMethodForInvoice.PayWithCheck]: PAYMENT_METHOD_KEY.CHECK,
  [ExistingPaymentMethodForInvoice.PayWithOther]: PAYMENT_METHOD_KEY.OTHER,
};

export const PAYMENT_METHOD_TYPE_MAP: Record<string, string> = {
  bank: PAYMENT_METHOD_KEY.ACH,
  card: PAYMENT_METHOD_KEY.CREDIT_CARD,
};
